// extracted by mini-css-extract-plugin
module.exports = {"container":"SpeakersListContainer_container__30jQX","draggingItem":"SpeakersListContainer_draggingItem__1mS3V"};